<template>
  <div>
    <div class="steps" v-if="!isMaxScreen">
      <div class="step">
        <div class="circle circlePosition">
          <div v-if="!isFinish0">1</div>
          <img v-else class="circle-img" :src="successIcon" alt="" />
          <div :class="['blank', { finish: isFinish1 }]"></div>
        </div>
        <div class="step-text">{{ $t('shippingLable.shippingLable.firstStep') }}</div>
      </div>
      <div class="step">
        <div class="circle circlePosition">
          <div v-if="!isFinish1">2</div>
          <img v-else class="circle-img" :src="successIcon" alt="" />
          <div :class="['blank', { finish: isFinish2 }]"></div>
        </div>
        <div class="step-text">{{ $t('shippingLable.shippingLable.649fhwp9zbo0') }}</div>
      </div>
      <div class="step">
        <div class="circle circlePosition">
          <div v-if="!isFinish2">3</div>
          <img v-else class="circle-img" :src="successIcon" alt="" />
          <div :class="['blank', { finish: isFinish3 }]"></div>
        </div>
        <div class="step-text step-text2">
          {{
            isFinish1
              ? $t('shippingLable.shippingLable.649fhwpa1900')
              : $t('shippingLable.shippingLable.649fhwpa1l00')
          }}
        </div>
      </div>
      <div class="step">
        <div class="circle">
          <div v-if="!isFinish3">4</div>
          <img v-else class="circle-img" :src="successIcon" alt="" />
        </div>
        <div class="step-text">{{ $t('shippingLable.shippingLable.649fhwpa1tc0') }}</div>
      </div>
    </div>

    <div class="step-box" v-else>
      <div class="width1200">
        <!-- <div v-if="isFinish2 || isFinish3" class="back" @click="back">
          <img src="@/assets/image/home/back-icon.png" alt="" />
          {{ $t('shippingLable.shippingLable.649fhwpa4ok0') }}
        </div> -->
        <div class="step-center">
          <div class="step">
            <div class="circle circlePosition">
              <div v-if="!isFinish0">1</div>
              <img v-else class="circle-img" :src="successIcon" alt="" />
              <div class="blank"></div>
            </div>
            {{ $t('shippingLable.shippingLable.firstStep') }}
          </div>

          <div class="horizontal-bar" :class="{ 'horizontal-bar2': isFinish1 }"></div>

          <div class="step">
            <div class="circle circlePosition">
              <div v-if="!isFinish1">2</div>
              <img v-else class="circle-img" :src="successIcon" alt="" />
              <div class="blank"></div>
            </div>
            {{ $t('shippingLable.shippingLable.649fhwp9zbo0') }}
          </div>

          <div class="horizontal-bar" :class="{ 'horizontal-bar2': isFinish2 }"></div>

          <div class="step">
            <div class="circle circlePosition">
              <div v-if="!isFinish2">3</div>
              <img v-else class="circle-img" :src="successIcon" alt="" />
            </div>
            {{ $t('shippingLable.shippingLable.649fhwpa1l00') }}
          </div>

          <div class="horizontal-bar" :class="{ 'horizontal-bar3': isFinish3 }"></div>

          <div class="step">
            <div class="circle circlePosition">
              <div v-if="!isFinish3">4</div>
              <img v-else class="circle-img" :src="successIcon" alt="" />
            </div>
            {{ $t('shippingLable.shippingLable.649fhwpa1tc0') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import successIcon from '../../assets/image/upload/2.png';
export default {
  name: 'step',
  components: {},
  props: {
    isFinish0: {
      type: Boolean,
      default: false
    },
    isFinish1: {
      type: Boolean,
      default: false
    },
    isFinish2: {
      type: Boolean,
      default: false
    },
    isFinish3: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      successIcon: successIcon,
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  created() {},
  mounted() {},
  methods: {},
  beforeDestroy() {}
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  .steps {
    display: flex;
    justify-content: space-evenly;
    text-align: center;
    margin-top: 26px;
    margin-bottom: 20px;

    .step {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      color: #8f949d;
      // width: 33.33%;
      width: 25%;
      flex-shrink: 0;
      .step-text {
        // width: 156px;
        // height: 68px;
        padding: 0 20px;
      }
      .step-text2 {
        // width: 106px;
      }
    }

    .circle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 46px;
      height: 46px;
      line-height: 46px;
      margin-bottom: 16px;
      background-color: #e9e7e7;
      border-radius: 100%;
      text-align: center;
      z-index: 100;
      color: #8f949d;
    }

    .circle-img {
      width: 30px;
      height: 30px;
    }

    .circlePosition {
      position: relative;

      .blank {
        position: absolute;
        left: 44px;
        top: 18px;
        // width: calc(500%);
        width: calc(400%);
        height: 10px;
        background-color: #e9e7e7;
        &.finish {
          background-color: #d6f4e9;
        }
      }
    }
  }
}

@media (min-width: 981px) {
  .back {
    color: #333;
    font-family: 'PingFang SC';
    font-size: 14px;
    font-weight: 500;
    position: absolute;
    left: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    img {
      width: 24px;
      height: 24px;
    }
  }

  .step-box {
    height: 120px;
    background-color: #f7f7f7;
    display: flex;
    justify-content: center;
  }
  .width1200 {
    width: 1680px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .step-center {
      display: flex;
      align-items: center;
      color: var(---Text-3, #8f949d);
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      .step {
        font-size: 18px;
        display: flex;
        align-items: center;
        flex: 1;
      }

      .circlePosition {
        width: 34px;
        height: 34px;
        flex-shrink: 0;
        border-radius: 50%;
        background-color: #e8e7e7;
        margin-right: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .circle-img {
        width: 30px;
        height: 30px;
      }

      .horizontal-bar {
        width: 125px;
        height: 2px;
        flex-shrink: 0;
        background: #e9e7e7;
        margin: 0 30px;
      }

      .horizontal-bar2 {
        background: #d6f4e9;
      }
      .horizontal-bar3 {
        background: #d6f4e9;
      }
    }
  }
}
</style>
